var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 26,
    viewBox: "0 0 38 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 4.04172V21.8393C38 23.6859 36.5083 25.1764 34.6602 25.1764H3.33984C1.49172 25.1764 0 23.6859 0 21.8393V4.04172C0 3.12966 0.378441 2.30637 0.957422 1.70578H0.979688L18.2875 11.5834C18.5102 11.7392 18.7552 11.8282 19 11.8282C19.2448 11.8282 19.4898 11.7393 19.7125 11.5834L37.0203 1.70578H37.0426C37.6216 2.30637 38 3.12966 38 4.04172Z",
    fill: "#FDBF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4.04172V21.8393C38 23.6859 36.5083 25.1764 34.6602 25.1764H19V11.8282C19.2449 11.8282 19.4898 11.7393 19.7125 11.5834L37.0203 1.70578H37.0426C37.6216 2.30637 38 3.12966 38 4.04172Z",
    fill: "#FF9F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8824 1.57166V1.59402L19.707 15.9893C19.486 16.1458 19.243 16.2352 19 16.2352C18.757 16.2352 18.514 16.1459 18.293 15.9893L1.11765 1.59402V1.57166C1.71429 0.96806 2.5539 0.588135 3.45973 0.588135H34.5403C35.4461 0.588135 36.2857 0.96806 36.8824 1.57166Z",
    fill: "#FFDE46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8824 1.57166V1.59402L19.707 15.9893C19.486 16.1458 19.243 16.2352 19 16.2352V0.588135H34.5403C35.4461 0.588135 36.2857 0.96806 36.8824 1.57166Z",
    fill: "#FFD400"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.cadb3e338d8a8691431688de3ed8d4ad.svg";
export { ForwardRef as ReactComponent };